import React from 'react';
import { translate } from 'react-i18next';
import {Form, Button, Label, Icon, Header} from 'semantic-ui-react'

import SurveyButtons from './SurveyButtons.js';
import {colors} from 'style';
import styleDef from './style.js';

var style = {
    ...styleDef,
    
}

const SurveyPageUnknown = ({t, 
                            surveyPage, 
                            inlineButtons, 
                            onSubmit, 
                            onSkip, 
                            pageNum, 
                            numPages}) => (
    <div style={style.container}>
    <div style={style.blank}>
        <div style={style.content}>
            <form onSubmit={onSubmit}>
                <div style={style.header}>{surveyPage.title}</div>

                <div style={style.pageCount}>
                    {t('page_{{pageNum}}_{{numPages}}',{pageNum, numPages})}
                </div>

                <div style={style.description}>
                    {t('unsupported_survey')}
                </div>
                <SurveyButtons onSubmit={onSkip} inlineButtons={inlineButtons} />
              
                {!inlineButtons &&
                    <div style={style.spacer} />       
                }
            </form>

            {/*<pre style={{textAlign: 'left'}}>{JSON.stringify(survey,null,2)}</pre>*/}
        </div>
    </div>
    </div>
);

export default translate('surveys')(SurveyPageUnknown);



// WEBPACK FOOTER //
// ./src/modules/surveys/types/SurveyPageUnknown.js